/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.13",
    versionName: "0.2.0-nightly.2025.11.13",
    versionChannel: "nightly",
    buildDate: "2025-11-13T00:07:50.162Z",
    commitHash: "5b8ff3a4d06eb8eb7fd651580a6e50f147c827e1",
};
